import { useEffect, useState } from "react"

import { BetbyBonusService, BetbyDbTemplate } from "services/betbyBonus/betbyBonus.service"

interface Props {
  onSelect: (template: BetbyDbTemplate) => void
}

export function TemplateSelector({ onSelect }: Props) {
  const [templates, setTemplates] = useState<BetbyDbTemplate[]>([])
  const [loading, setLoading] = useState(true)
  const [selectedId, setSelectedId] = useState<string>("")

  useEffect(() => {
    BetbyBonusService.getTemplates(true).then((data) => {
      setTemplates(data)
      setLoading(false)
    })
  }, [])

  const handleChange = (id: string) => {
    setSelectedId(id)
    const found = templates.find((t) => t.id === id)
    if (found) onSelect(found)
  }

  if (loading) {
    return <div className="text-gray-500 text-sm">Loading enabled templates…</div>
  }

  if (templates.length === 0) {
    return (
      <div className="p-3 bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-300 dark:border-yellow-700 rounded text-yellow-800 dark:text-yellow-200 text-sm">
        No enabled templates found. Go to the <strong>Templates</strong> tab to sync and enable templates.
      </div>
    )
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Select bonus template</label>
      <select
        className="w-full max-w-lg px-3 py-2 text-sm border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        value={selectedId}
        onChange={(e) => handleChange(e.target.value)}
      >
        <option value="">— choose a template —</option>
        {templates.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name} — {t.type}
            {t.default_amount_cents !== null
              ? ` — default $${(t.default_amount_cents / 100).toFixed(2)} ${t.default_currency ?? ""}`
              : t.freebet_data?.amount_list?.[0]
              ? ` — BetBy default $${(t.freebet_data.amount_list[0] / 100).toFixed(2)}`
              : ""}
          </option>
        ))}
      </select>
    </div>
  )
}
